export const replaces = {
    '"@msft-sme/ui-test-automation": "3.5.0"': '"@msft-sme/ui-test-automation": "4.80.0"',
    '"@playwright/test": "1.20.1"': '"@playwright/test": "1.31.0"',
    '"@types/jasmine": "~3.6.0"': '"@types/jasmine": "4.3.5"',
    '"@types/node": "^12.11.1"': '"@types/node": "20.5.9"',
    '"@types/jasmine": "3.6.0"': '"@types/jasmine": "4.3.5"',
    '"@types/node": "12.11.1"': '"@types/node": "20.5.9"'
}

export const adds = [
    {
        toBeAdded: '"playwright-core": "1.31.0"',
        toBeAddedAfter: '"@playwright/test": "1.31.0"',
        keyword: '"playwright-core"',
        indent: 4
    }
];